import PermissionsTemplatesButtonController from "./PermissionsTemplatesButtonController"
import PermissionsTemplatesMenuWithoutChoosing from "./PermissionsTemplatesMenuWithoutChoosing"

export default class PermissionsTemplateButtonControllerWithoutChoosing extends PermissionsTemplatesButtonController {
    constructor($containerEl, $button, onChangeTemplates = () => {}) {
        super({
            $containerEl,
            $button,
            withoutChoosing: true,
            onChangeTemplates,
            additionalClassName: 'onBulkInvitations rightArrow',
        })
    }

    createAndInitPermissionTemplatesMenu(permissionsTemplates) {
        const context = this;
        this.permissionTemplatesMenu = new PermissionsTemplatesMenuWithoutChoosing().init({
                menuId: "permissionTemplatesMenuWithoutChoosingId",
                templatesData: permissionsTemplates,
                onCreateTemplateCallback: this._handleCreateTemplate,
                onEditTemplateCallback: this._handleEditTemplate,
                onSelectTemplateCallback: () => {},
                onErrorCallback: (data) => this.setState({templates: data}),
                onDeleteCallback: null,
                canShowMenu: () => true
            }
        )

        const showMenuCallback = function(event) {
            context.permissionTemplatesMenu.showAt(context.$containerEl, context.$permissionTemplatesMenuButton, {left: -50});
            context.permissionTemplatesMenu.getMenuElement().addClass('rightAlignedArrow');
        };
        this.$permissionTemplatesMenuButton.off("click").on("click", showMenuCallback);
    }

}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/permissionsTemplates/PermissionsTemplateButtonControllerWithoutChoosing.js